import { useSelector }  from "react-redux";
import Plan             from "../../../domain/plan/Plan";
import { ResKaState }   from "../../../index";
import ResKaReduxAction from "../ResKaReduxAction";

enum SelectedPlanActionType {
  INIT_SELECTED_PLAN = "INIT_SELECTED_PLAN",
  SET_SELECTED_PLAN = "SET_SELECTED_PLAN",
}

interface InitSelectedPlanAction extends ResKaReduxAction {
}

interface SetSelectedPlanAction extends ResKaReduxAction {
  plan: Plan;
}

type SelectedPlanAction = InitSelectedPlanAction | SetSelectedPlanAction;

export const initSelectedPlanAction = (): InitSelectedPlanAction => ({
  type: SelectedPlanActionType.INIT_SELECTED_PLAN,
});

export const setSelectedPlanAction = (plan: Plan): SetSelectedPlanAction => ({
  type: SelectedPlanActionType.SET_SELECTED_PLAN,
  plan: plan,
});

export const selectedPlanReducer = (state: Plan = new Plan(), action: SelectedPlanAction): Plan => {
  switch (action.type) {
    default:
      return state;
    case SelectedPlanActionType.INIT_SELECTED_PLAN:
      return new Plan();
    case SelectedPlanActionType.SET_SELECTED_PLAN:
      return (action as SetSelectedPlanAction).plan;
  }
}

export const useSelectedPlan = (): Plan => useSelector((state: ResKaState) => state.selectedPlan);
